import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Iterable } from 'immutable';
import isFunction from 'lodash/isFunction';
import { userSettings as userSettingsSelector } from '@Containers/UserDetails/UserDetailsSelectors';

const useUserSettings = (callback) => {
  const userSettings = useSelector(userSettingsSelector);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (userSettings && isFunction(callback)) {
      return callback(Iterable.isIterable(userSettings) ? userSettings.toJS() : userSettings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSettings]);
};

export default useUserSettings;
